import React, {Component} from 'react';
import * as R from 'ramda';

import Button from 'js/components/button';
import ConfigurableStar from 'js/components/configurable_star';
import Rate from 'js/components/rate';
import WorkflowPanel from 'js/components/workflow_panel';

import './index.scss';

export default class RateContent extends Component {
    static defaultProps = {
        onRating: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            rating: props.rating
        };
    }

    onRating = (rating) => {
        const {onRating} = this.props;
        this.setState({rating});
        onRating(rating);
    };

    renderButtons() {
        const {onNext, isTransmitting} = this.props;
        const {rating} = this.state;
        return [
            <Button
                primary
                key="next"
                disabled={R.isNil(rating) || isTransmitting}
                className="rate-content__button"
                onClick={onNext}
            >
                Next
            </Button>
        ];
    }

    render() {
        return (
            <WorkflowPanel sameSizeButtons className="rate-content" buttons={this.renderButtons()}>
                <div className="rate-content__image" />
                <div className="rate-content__heading">Hooray! This content has been approved</div>
                <div className="rate-content__subheading">
                    To improve future matching, rate this content:
                </div>
                <Rate items={5} icon={ConfigurableStar} onRating={this.onRating} />
            </WorkflowPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/rate_content/index.js